import { memo, useCallback, useState } from 'react'

import { ContactHPRoles, IContact, TContactFormKeys } from 'clickNgo/entities/contact'
import { IPartner } from 'clickNgo/entities/partner/models'
import { formatErrorMessages } from 'clickNgo/helpers/api'
import { IAccessibility } from 'clickNgo/models/widget'
import { InfoBlock, InfoBlockRounded, InfoBlockType } from 'cng-common/components/infoBlock'
import { LoaderOverlay } from 'cng-common/components/loaderOverlay'
import { RenderWhen } from 'cng-common/components/renderWhen'
import { FieldGroup } from 'shared/components/fieldGroup'
import { IWizardStepProps } from 'shared/components/wizard'

import { PartnerHPRoles } from './components'
import { compareProps } from './helpers'
import { useHPRoleChange } from './hooks'

import styles from './HPRolesStep.module.scss'

interface IProps extends Partial<IWizardStepProps>, IAccessibility {
  partner: IPartner
  contact: IContact
  formKeys: TContactFormKeys
  errorMessages: string[]
}

export const HPRolesStep = memo<IProps>((props) => {
  const [isLoading, setIsLoading] = useState(false)
  const { handleOnHPRolesChange } = useHPRoleChange(props)

  const handleOnChange = useCallback(
    async (values: string[]) => {
      setIsLoading(true)
      await handleOnHPRolesChange(values)
      setIsLoading(false)
    },
    [handleOnHPRolesChange]
  )

  return (
    <>
      <RenderWhen condition={Boolean(props.errorMessages.length)}>
        <InfoBlock
          text={formatErrorMessages(props.errorMessages)}
          type={InfoBlockType.Danger}
          rounded={InfoBlockRounded.Medium}
          hasCloseButton
        />
      </RenderWhen>
      <div className={styles.container}>
        <LoaderOverlay isVisible={isLoading} color={'white'} />
        <ContactHPRoles {...props} onHPRolesChange={handleOnChange} isCollapsible />
        <FieldGroup title={'Partner HP Roles'} size={1}>
          <PartnerHPRoles
            partner={props.partner}
            formKeys={props.formKeys}
            onLoading={setIsLoading}
          />
        </FieldGroup>
      </div>
    </>
  )
}, compareProps)
